import { Box, HStack, Image, Text, useMediaQuery } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Info } from "src/components";
import { colors } from "src/theme";

const TRUSTED_LOGOS = [
  {
    src: "https://assets.awaken.tax/icons/phantom.png",
    alt: "Phantom",
  },
  {
    src: "https://assets.awaken.tax/icons/solana.png",
    alt: "Solana",
  },
  {
    src: "https://assets.awaken.tax/icons/metamask.png",
    alt: "MetaMask",
  },
  {
    src: "https://assets.awaken.tax/icons/coinbase.png",
    alt: "Coinbase",
  },
  {
    src: "https://assets.awaken.tax/icons/magiceden.png",
    alt: "Magic Eden",
  },
  {
    src: "https://assets.awaken.tax/icons/opensea.png",
    alt: "OpenSea",
  },
  {
    src: "https://assets.awaken.tax/icons/kraken.png",
    alt: "Kraken",
  },
  {
    src: "https://assets.awaken.tax/icons/offchainlabs.png",
    alt: "Offchain Labs",
  },
  {
    src: "https://assets.awaken.tax/icons/osmosis.png",
    alt: "Osmosis",
  },
  {
    src: "https://assets.awaken.tax/icons/hyperlane.jpg",
    alt: "HyperLane",
  },
];

export const TrustedBy = () => {
  const [isLargerThan800] = useMediaQuery("(min-width: 800px)");
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setOffset((prevOffset) => prevOffset + 0.25);
    }, 10);
    return () => clearInterval(intervalId);
  }, []);

  const totalWidth = TRUSTED_LOGOS.length * 200;

  return (
    <Box bg={colors.black} py={isLargerThan800 ? 10 : 6} mt={8}>
      <Text
        color={colors.gray3}
        textAlign="center"
        fontSize="sm"
        textTransform="uppercase"
        letterSpacing="wider"
        fontWeight="bold"
        mb={8}
      >
        Trusted by people from{" "}
        <Info
          style={{
            color: colors.gray3,
          }}
          message="Many big crypto influencers as well as people who work at top crypto companies trust Awaken for their taxes."
        />
      </Text>

      <Box
        position="relative"
        width="100%"
        overflow="hidden"
        maxW="1200px"
        mx="auto"
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          pointerEvents="none"
          zIndex={1}
          bgGradient={`linear(to-r, ${colors.black} 0%, transparent 15%, transparent 85%, ${colors.black} 100%)`}
        />
        <Box
          display="flex"
          gap={8}
          px={4}
          whiteSpace="nowrap"
          width="fit-content"
          style={{
            transform: `translateX(-${offset % totalWidth}px)`,
          }}
        >
          {[...TRUSTED_LOGOS, ...TRUSTED_LOGOS].map((logo, index) => (
            <HStack key={index} flexShrink={0}>
              <Image
                src={logo.src}
                alt={logo.alt}
                height="45px"
                borderRadius={100}
                objectFit="contain"
                border={"1px solid " + colors.gray30}
                filter="brightness(0.8)"
                transition="filter 0.2s"
                _hover={{ filter: "brightness(1)" }}
              />
              <Text
                color={colors.gray3}
                textAlign="center"
                fontSize="md"
                textTransform="uppercase"
                letterSpacing="wider"
                mb={6}
                fontWeight="bold"
              >
                {logo.alt}
              </Text>
            </HStack>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
